import React from 'react';

import {
  SvgIconProps,
  useTheme
} from '@mui/material';

import { ReactComponent as Account } from '../../../../assets/icons/large/account.svg';
import { ReactComponent as Woodwork } from '../../../../assets/icons/large/woodwork.svg';
import { ReactComponent as Wrench } from '../../../../assets/icons/large/wrench.svg';
import { ReactComponent as Zip } from '../../../../assets/icons/large/zip.svg';
import { ReactComponent as Info } from '../../../../assets/icons/large/info.svg';
import { ReactComponent as Menu } from '../../../../assets/icons/large/menu.svg';
import { ReactComponent as Menualt } from '../../../../assets/icons/large/menuAlt.svg';
import { ReactComponent as Question } from '../../../../assets/icons/large/question.svg';
import { ReactComponent as Questionalt } from '../../../../assets/icons/large/questionAlt.svg';
import { ReactComponent as Task } from '../../../../assets/icons/large/task.svg';
import { ReactComponent as Team } from '../../../../assets/icons/large/team.svg';
import { ReactComponent as Morehorizontal } from '../../../../assets/icons/large/moreHorizontal.svg';
import { ReactComponent as Morehorizontalalt } from '../../../../assets/icons/large/moreHorizontalAlt.svg';
import { ReactComponent as Morevertical } from '../../../../assets/icons/large/moreVertical.svg';
import { ReactComponent as Clock } from '../../../../assets/icons/large/clock.svg';
import { ReactComponent as Clockalt } from '../../../../assets/icons/large/clockAlt.svg';
import { ReactComponent as Upload } from '../../../../assets/icons/large/upload.svg';
import { ReactComponent as Uploadalt } from '../../../../assets/icons/large/uploadAlt.svg';
import { ReactComponent as Alert } from '../../../../assets/icons/large/alert.svg';
import { ReactComponent as Area } from '../../../../assets/icons/large/area.svg';
import { ReactComponent as Assign } from '../../../../assets/icons/large/assign.svg';
import { ReactComponent as Basearrow } from '../../../../assets/icons/large/baseArrow.svg';
import { ReactComponent as Bathroom } from '../../../../assets/icons/large/bathroom.svg';
import { ReactComponent as Bed } from '../../../../assets/icons/large/bed.svg';
import { ReactComponent as Bell } from '../../../../assets/icons/large/bell.svg';
import { ReactComponent as Bookmark } from '../../../../assets/icons/large/bookmark.svg';
import { ReactComponent as Box } from '../../../../assets/icons/large/box.svg';
import { ReactComponent as Brush } from '../../../../assets/icons/large/brush.svg';
import { ReactComponent as Bulb } from '../../../../assets/icons/large/bulb.svg';
import { ReactComponent as Cabinet } from '../../../../assets/icons/large/cabinet.svg';
import { ReactComponent as Calendaralt } from '../../../../assets/icons/large/calendarAlt.svg';
import { ReactComponent as Calendaralt2 } from '../../../../assets/icons/large/calendarAlt2.svg';
import { ReactComponent as Chequeredflag } from '../../../../assets/icons/large/chequeredFlag.svg';
import { ReactComponent as Clockalt2 } from '../../../../assets/icons/large/clockAlt2.svg';
import { ReactComponent as Cloudforecast } from '../../../../assets/icons/large/cloudForecast.svg';
import { ReactComponent as Compress } from '../../../../assets/icons/large/compress.svg';
import { ReactComponent as Createtask } from '../../../../assets/icons/large/createTask.svg';
import { ReactComponent as Creator } from '../../../../assets/icons/large/creator.svg';
import { ReactComponent as Cross } from '../../../../assets/icons/large/cross.svg';
import { ReactComponent as Crown } from '../../../../assets/icons/large/crown.svg';
import { ReactComponent as Crownalt } from '../../../../assets/icons/large/crownAlt.svg';
import { ReactComponent as Cutlery } from '../../../../assets/icons/large/cutlery.svg';
import { ReactComponent as Dashboard } from '../../../../assets/icons/large/dashboard.svg';
import { ReactComponent as Delete } from '../../../../assets/icons/large/delete.svg';
import { ReactComponent as Delivery } from '../../../../assets/icons/large/delivery.svg';
import { ReactComponent as Doc } from '../../../../assets/icons/large/doc.svg';
import { ReactComponent as Door } from '../../../../assets/icons/large/door.svg';
import { ReactComponent as Dragndrop } from '../../../../assets/icons/large/dragndrop.svg';
import { ReactComponent as Drawcompass } from '../../../../assets/icons/large/drawCompass.svg';
import { ReactComponent as Drawcompassapproved } from '../../../../assets/icons/large/drawCompassApproved.svg';
import { ReactComponent as Duplicate } from '../../../../assets/icons/large/duplicate.svg';
import { ReactComponent as Edit } from '../../../../assets/icons/large/edit.svg';
import { ReactComponent as Empty } from '../../../../assets/icons/large/empty.svg';
import { ReactComponent as Emptyalt } from '../../../../assets/icons/large/emptyAlt.svg';
import { ReactComponent as Extend } from '../../../../assets/icons/large/extend.svg';
import { ReactComponent as Eyeclosed } from '../../../../assets/icons/large/eyeClosed.svg';
import { ReactComponent as Eyeopen } from '../../../../assets/icons/large/eyeOpen.svg';
import { ReactComponent as File } from '../../../../assets/icons/large/file.svg';
import { ReactComponent as Filter } from '../../../../assets/icons/large/filter.svg';
import { ReactComponent as Fog } from '../../../../assets/icons/large/fog.svg';
import { ReactComponent as Hourglass } from '../../../../assets/icons/large/hourglass.svg';
import { ReactComponent as Link } from '../../../../assets/icons/large/link.svg';
import { ReactComponent as Livingroom } from '../../../../assets/icons/large/livingRoom.svg';
import { ReactComponent as Messages } from '../../../../assets/icons/large/messages.svg';
import { ReactComponent as Minus } from '../../../../assets/icons/large/minus.svg';
import { ReactComponent as Model } from '../../../../assets/icons/large/model.svg';
import { ReactComponent as Notif } from '../../../../assets/icons/large/notif.svg';
import { ReactComponent as Outside } from '../../../../assets/icons/large/outside.svg';
import { ReactComponent as Passport } from '../../../../assets/icons/large/passport.svg';
import { ReactComponent as Pin } from '../../../../assets/icons/large/pin.svg';
import { ReactComponent as Play } from '../../../../assets/icons/large/play.svg';
import { ReactComponent as Plus } from '../../../../assets/icons/large/plus.svg';
import { ReactComponent as Qr } from '../../../../assets/icons/large/qr.svg';
import { ReactComponent as Quantity } from '../../../../assets/icons/large/quantity.svg';
import { ReactComponent as Rain } from '../../../../assets/icons/large/rain.svg';
import { ReactComponent as Result } from '../../../../assets/icons/large/result.svg';
import { ReactComponent as Room } from '../../../../assets/icons/large/room.svg';
import { ReactComponent as Search } from '../../../../assets/icons/large/search.svg';
import { ReactComponent as Settings } from '../../../../assets/icons/large/settings.svg';
import { ReactComponent as Shop } from '../../../../assets/icons/large/shop.svg';
import { ReactComponent as Snow } from '../../../../assets/icons/large/snow.svg';
import { ReactComponent as Sparkle } from '../../../../assets/icons/large/sparkle.svg';
import { ReactComponent as Stop } from '../../../../assets/icons/large/stop.svg';
import { ReactComponent as Subcontractor } from '../../../../assets/icons/large/subcontractor.svg';
import { ReactComponent as Suitcase } from '../../../../assets/icons/large/suitcase.svg';
import { ReactComponent as Sun } from '../../../../assets/icons/large/sun.svg';
import { ReactComponent as Tasks } from '../../../../assets/icons/large/tasks.svg';
import { ReactComponent as Tasksalt } from '../../../../assets/icons/large/tasksAlt.svg';
import { ReactComponent as Temphigh } from '../../../../assets/icons/large/tempHigh.svg';
import { ReactComponent as Templow } from '../../../../assets/icons/large/tempLow.svg';
import { ReactComponent as Tie } from '../../../../assets/icons/large/tie.svg';
import { ReactComponent as Timemachine } from '../../../../assets/icons/large/timeMachine.svg';
import { ReactComponent as Unlink } from '../../../../assets/icons/large/unlink.svg';
import { ReactComponent as Upcoming } from '../../../../assets/icons/large/upcoming.svg';
import { ReactComponent as Update } from '../../../../assets/icons/large/update.svg';
import { ReactComponent as Weight } from '../../../../assets/icons/large/weight.svg';
import { ReactComponent as Alertcircle } from '../../../../assets/icons/large/alertCircle.svg';
import { ReactComponent as Alerttriangle } from '../../../../assets/icons/large/alertTriangle.svg';
import { ReactComponent as Downarrow } from '../../../../assets/icons/large/downArrow.svg';
import { ReactComponent as Leftarrow } from '../../../../assets/icons/large/leftArrow.svg';
import { ReactComponent as Rightarrow } from '../../../../assets/icons/large/rightArrow.svg';
import { ReactComponent as Uparrow } from '../../../../assets/icons/large/upArrow.svg';
import { ReactComponent as Chart } from '../../../../assets/icons/large/chart.svg';
import { ReactComponent as Checkfilled } from '../../../../assets/icons/large/checkFilled.svg';
import { ReactComponent as Checkflat } from '../../../../assets/icons/large/checkFlat.svg';
import { ReactComponent as Close } from '../../../../assets/icons/large/close.svg';
import { ReactComponent as Folder } from '../../../../assets/icons/large/folder.svg';
import { ReactComponent as Addfolder } from '../../../../assets/icons/large/addFolder.svg';
import { ReactComponent as Folderalt } from '../../../../assets/icons/large/folderAlt.svg';
import { ReactComponent as Dowload } from '../../../../assets/icons/large/dowload.svg';
import { ReactComponent as Editsmaller } from '../../../../assets/icons/large/editSmaller.svg';
import { ReactComponent as Editalt } from '../../../../assets/icons/large/editAlt.svg';
import { ReactComponent as Plan } from '../../../../assets/icons/large/plan.svg';
import { ReactComponent as Star } from '../../../../assets/icons/large/star.svg';
import { ReactComponent as Tag } from '../../../../assets/icons/large/tag.svg';

export type CustomIconProps = {
  icon: IconTypes;
};

export type IconTypes =
  'ACCOUNT' |
  'ADDFOLDER' |
  'ALERT' |
  'ALERTCIRCLE' |
  'ALERTTRIANGLE' |
  'AREA' |
  'ASSIGN' |
  'BASEARROW' |
  'BATHROOM' |
  'BED' |
  'BELL' |
  'BOOKMARK' |
  'BOX' |
  'BRUSH' |
  'BULB' |
  'CABINET' |
  'CALENDARALT' |
  'CALENDARALT2' |
  'CHART' |
  'CHECKFILLED' |
  'CHECKFLAT' |
  'CHEQUEREDFLAG' |
  'CLOCK' |
  'CLOCKALT' |
  'CLOCKALT2' |
  'CLOSE' |
  'CLOUDFORECAST' |
  'COMPRESS' |
  'CREATETASK' |
  'CREATOR' |
  'CROSS' |
  'CROWN' |
  'CROWNALT' |
  'CUTLERY' |
  'DASHBOARD' |
  'DELETE' |
  'DELIVERY' |
  'DOC' |
  'DOOR' |
  'DOWLOAD' |
  'DOWNARROW' |
  'DRAGNDROP' |
  'DRAWCOMPASS' |
  'DRAWCOMPASSAPPROVED' |
  'DUPLICATE' |
  'EDIT' |
  'EDITALT' |
  'EDITSMALLER' |
  'EMPTY' |
  'EMPTYALT' |
  'EXTEND' |
  'EYECLOSED' |
  'EYEOPEN' |
  'FILE' |
  'FOG' |
  'FILTER' |
  'FOLDER' |
  'FOLDERALT' |
  'HOURGLASS' |
  'INFO' |
  'LEFTARROW' |
  'LINK' |
  'LIVINGROOM' |
  'MENU' |
  'MENUALT' |
  'MESSAGES' |
  'MINUS' |
  'MODEL' |
  'MOREHORIZONTAL' |
  'MOREHORIZONTALALT' |
  'MOREVERTICAL' |
  'NOTIF' |
  'OUTSIDE' |
  'PASSPORT' |
  'PIN' |
  'PLAY' |
  'PLAN' |
  'PLUS' |
  'QR' |
  'QUANTITY' |
  'QUESTION' |
  'QUESTIONALT' |
  'RAIN' |
  'RESULT' |
  'RIGHTARROW' |
  'ROOM' |
  'SEARCH' |
  'SETTINGS' |
  'SHOP' |
  'SNOW' |
  'SPARKLE' |
  'STOP' |
  'SUBCONTRACTOR' |
  'SUITCASE' |
  'SUN' |
  'TASK' |
  'TAG' |
  'TASKS' |
  'TASKSALT' |
  'TEAM' |
  'TEMPHIGH' |
  'TEMPLOW' |
  'TIE' |
  'TIMEMACHINE' |
  'UNLINK' |
  'UPARROW' |
  'UPCOMING' |
  'UPDATE' |
  'UPLOAD' |
  'UPLOADALT' |
  'WEIGHT' |
  'WOODWORK' |
  'WRENCH' |
  'STAR' |
  'ZIP';



export const __icon2iconUrl: Record<IconTypes, React.ReactElement> = {
  ACCOUNT: <Account />,
  ADDFOLDER: <Addfolder />,
  ALERT: <Alert />,
  ALERTCIRCLE: <Alertcircle />,
  ALERTTRIANGLE: <Alerttriangle />,
  AREA: <Area />,
  ASSIGN: <Assign />,
  BASEARROW: <Basearrow />,
  BATHROOM: <Bathroom />,
  BED: <Bed />,
  BELL: <Bell />,
  BOOKMARK: <Bookmark />,
  BOX: <Box />,
  BRUSH: <Brush />,
  BULB: <Bulb />,
  CABINET: <Cabinet />,
  CALENDARALT: <Calendaralt />,
  CALENDARALT2: <Calendaralt2 />,
  CHART: <Chart />,
  CHECKFILLED: <Checkfilled />,
  CHECKFLAT: <Checkflat />,
  CHEQUEREDFLAG: <Chequeredflag />,
  CLOCK: <Clock />,
  CLOCKALT: <Clockalt />,
  CLOCKALT2: <Clockalt2 />,
  CLOSE: <Close />,
  CLOUDFORECAST: <Cloudforecast />,
  COMPRESS: <Compress />,
  CREATETASK: <Createtask />,
  CREATOR: <Creator />,
  CROSS: <Cross />,
  CROWN: <Crown />,
  CROWNALT: <Crownalt />,
  CUTLERY: <Cutlery />,
  DASHBOARD: <Dashboard />,
  DELETE: <Delete />,
  DELIVERY: <Delivery />,
  DOC: <Doc />,
  DOOR: <Door />,
  DOWLOAD: <Dowload />,
  DOWNARROW: <Downarrow />,
  DRAGNDROP: <Dragndrop />,
  DRAWCOMPASS: <Drawcompass />,
  DRAWCOMPASSAPPROVED: <Drawcompassapproved />,
  DUPLICATE: <Duplicate />,
  EDIT: <Edit />,
  EDITALT: <Editalt />,
  EDITSMALLER: <Editsmaller />,
  EMPTY: <Empty />,
  EMPTYALT: <Emptyalt />,
  EXTEND: <Extend />,
  EYECLOSED: <Eyeclosed />,
  EYEOPEN: <Eyeopen />,
  FILE: <File />,
  FILTER: <Filter />,
  FOG: <Fog />,
  FOLDER: <Folder />,
  FOLDERALT: <Folderalt />,
  HOURGLASS: <Hourglass />,
  INFO: <Info />,
  LEFTARROW: <Leftarrow />,
  LINK: <Link />,
  LIVINGROOM: <Livingroom />,
  MENU: <Menu />,
  MENUALT: <Menualt />,
  MESSAGES: <Messages />,
  MINUS: <Minus />,
  MODEL: <Model />,
  MOREHORIZONTAL: <Morehorizontal />,
  MOREHORIZONTALALT: <Morehorizontalalt />,
  MOREVERTICAL: <Morevertical />,
  NOTIF: <Notif />,
  OUTSIDE: <Outside />,
  PASSPORT: <Passport />,
  PIN: <Pin />,
  PLAN: <Plan />,
  PLAY: <Play />,
  PLUS: <Plus />,
  QR: <Qr />,
  QUANTITY: <Quantity />,
  QUESTION: <Question />,
  QUESTIONALT: <Questionalt />,
  RAIN: <Rain />,
  RESULT: <Result />,
  RIGHTARROW: <Rightarrow />,
  ROOM: <Room />,
  SEARCH: <Search />,
  SETTINGS: <Settings />,
  SHOP: <Shop />,
  SNOW: <Snow />,
  SPARKLE: <Sparkle />,
  STAR: <Star />,

  STOP: <Stop />,
  SUBCONTRACTOR: <Subcontractor />,
  SUITCASE: <Suitcase />,
  SUN: <Sun />,
  TAG: <Tag />,
  TASK: <Task />,
  TASKS: <Tasks />,
  TASKSALT: <Tasksalt />,
  TEAM: <Team />,
  TEMPHIGH: <Temphigh />,
  TEMPLOW: <Templow />,
  TIE: <Tie />,
  TIMEMACHINE: <Timemachine />,
  UNLINK: <Unlink />,
  UPARROW: <Uparrow />,
  UPCOMING: <Upcoming />,
  UPDATE: <Update />,
  UPLOAD: <Upload />,
  UPLOADALT: <Uploadalt />,
  WEIGHT: <Weight />,
  WOODWORK: <Woodwork />,
  WRENCH: <Wrench />,
  ZIP: <Zip />
};

export const FC = (props: CustomIconProps & SvgIconProps) => {
  const theme = useTheme();
  const Res = __icon2iconUrl[props.icon];
  const stroke = props.stroke
    ? props.stroke
    : theme.palette.customGray.dark;

  return (

    <Res.type
      {...props}
      stroke={stroke}
    />
  );
};
